import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/authService/auth.service';
import { KEYS } from '../constants';
import { Router } from '@angular/router';
@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,private router: Router) {}
  
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let token: any;
    const isGuestApi =
  request.url.includes('/guest-user');
  if(!isGuestApi){
    this.authService.checkToken();
     token = localStorage.getItem(KEYS.TOKEN); // Retrieve the token from wherever you have stored it
  }else{
      token = localStorage.getItem('guestToken')
  }
    // console.log('ApiInterceptor', token);
    // Clone the request and add the token to the headers
    const modifiedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Pass the modified request to the next handler
    return next.handle(modifiedRequest);
  }
}
